import {fetch, normalize} from "utils/dataAccess";

export default function create(variationId, values) {
    values["variation"] = variationId;

    return new Promise((resolve, reject) => {
        fetch('/variation_locks', {
            method: "POST",
            body: JSON.stringify(values),
        }).then(response => response.json()).then((retrieved) => {
            resolve(normalize(retrieved));
        }).catch(error => reject(error.message));
    });
}
